import { checkItem } from "ui/files/others/FilterCheckItem";
import { monthDays } from "./dates";

export const filterPostType: checkItem[] = [
    {
        label: "All",
        checked: true
    },
    {
        label: "Post",
        checked: false
    },
    {
        label: "Incident",
        checked: false
    }
];

export const daysFilter: checkItem[] = [
    {
        label: "All",
        checked: true
    },
    {
        label: "Saturday",
        checked: false
    },
    {
        label: "Sunday",
        checked: false
    },
    {
        label: "Monday",
        checked: false
    },
    {
        label: "Tuesday",
        checked: false
    },
    {
        label: "Wednesday",
        checked: false
    },
    {
        label: "Thursday",
        checked: false
    },
    {
        label: "Friday",
        checked: false
    }
];

export const monthsFilter: checkItem[] = [
    {
        label: "All",
        checked: true
    },
    {
        label: "January",
        checked: false
    },
    {
        label: "February",
        checked: false
    },
    {
        label: "March",
        checked: false
    },
    {
        label: "April",
        checked: false
    },
    {
        label: "May",
        checked: false
    },
    {
        label: "June",
        checked: false
    },
    {
        label: "July",
        checked: false
    },
    {
        label: "August",
        checked: false
    },
    {
        label: "September",
        checked: false
    },
    {
        label: "October",
        checked: false
    },
    {
        label: "November",
        checked: false
    },
    {
        label: "December",
        checked: false
    }
];

export const yearsFilter: checkItem[] = [
    {
        label: "All",
        checked: true
    },
    {
        label: "2023",
        checked: false
    },
    {
        label: "2024",
        checked: false
    }
];

const tempMonthDays: checkItem[] = monthDays.map((i) => ({
    label: `${i}`,
    checked: false
}));
export const monthDaysFilter: checkItem[] = [
    {
        label: "All",
        checked: true
    },
    ...tempMonthDays
];

export const spamFilterItems: checkItem[] = [
    { label: "All", checked: true },
    { label: "murder", checked: false },
    { label: "viagra", checked: false },
    { label: "low cost", checked: false },
    { label: "avoid bankruptcy", checked: false },
    { label: "xanax", checked: false },
    { label: "vicodin", checked: false },
    { label: "discreet", checked: false },
    { label: "casino", checked: false },
    { label: "teen", checked: false },
    { label: "unsolicited", checked: false },
    { label: "removel instractions", checked: false },
    { label: "babes", checked: false },
    { label: "financial freedom", checked: false },
    { label: "offer expires", checked: false },
    { label: "make money", checked: false },
    { label: "work from home", checked: false },
    { label: "mortgage rates", checked: false },
    { label: "free gift damage", checked: false },
    { label: "reps", checked: false },
    { label: "accident", checked: false },
    { label: "kill", checked: false }
];
